import {BMS_LOGIC, NEXT_EVENT_DISPLAY_MODE} from "../constants/bmsLogic";
import {checkFetchResponseStatus, parseFetchResponseJSON} from "./commsHelpers";
import {
    calculateAndSetServerTimeOffset,
    handleFetchNextEventsListAndLastResults,
    handleFetchNextEventsTime
} from "./platformMessageHandlers";
import {CURRENT_NEXT} from "../constants/identifiers";
import {setMatchdayUpdate, setResult} from "../actions/eventsActions";
import {MATCHDAY_MODULE_TYPE} from "../ui-modules/sports-book/modules/matchday/constants/identifiers";
import { isTextBasedGame } from '../ui-modules/sports-book/modules/matchday/helpers/matchdayHelper.js';

export function onEventFinishedNotification(params, store) {
    if (store !== undefined) {
        let storeData = store.getState();
        let games = storeData.vpp.games;
        let selectedGameIndex = storeData.vpp.selectedGameIndex;
        let selectedGame = games[selectedGameIndex];
        store.dispatch(setResult(params));

        let resultedGame = games.find((game) => game.channel === params.channel);
        if (resultedGame !== undefined && resultedGame.type === MATCHDAY_MODULE_TYPE
            && (resultedGame.lastResult === undefined || (resultedGame.lastResult && resultedGame.lastResult.length !== 8))) {
            return;
        }

        let channelEvents = storeData.vpp.nextEventsTimeStamp.slice().filter((evt) => evt.channel === params.channel);

        if (channelEvents.length !== 0 && resultedGame !== undefined && resultedGame.type === MATCHDAY_MODULE_TYPE) {
            let lastMatchdayEvents = channelEvents.slice(channelEvents.length - 8, channelEvents.length);

            let event = lastMatchdayEvents.find((event) => event.eventId === Number(params.eventId));
            if (event != undefined) {
                getNextEventsTime(store.dispatch);
            }
        } else if (channelEvents.length === 0 || channelEvents[channelEvents.length - 1].eventId <= Number(params.eventId)) {
            getNextEventsTime(store.dispatch);
        }
        // if a finished event notification is received for the selected game, new
        // events and time stamps must be fetched...
        if (selectedGame.channel === params.channel) {
            setTimeout(() => getNextEventsListAndLastResults(selectedGame.channel, selectedGame.type, store.dispatch), 2000);
        }
        // sync server time offset to get the countdown timers right
        calculateAndSetServerTimeOffset(params.resultTime, store.dispatch)
    }
}

export function onMatchdayUpdateNotification(params, store) {
    if (store !== undefined) {
        store.dispatch(setMatchdayUpdate(params));
    }
}

export function getNextEventsLastResultsAndNextEventsTime(channel, gameType, store) {
    fetchNextEventsListAndLastResults(channel, gameType)
        .then((res) => handleFetchNextEventsListAndLastResults(res, store))
        .then(fetchNextEventsTime)
        .then((res) => handleFetchNextEventsTime(res, store));
}

export function getNextEventsListAndLastResults(channel, gameType, store) {
    fetchNextEventsListAndLastResults(channel, gameType)
        .then((res) => handleFetchNextEventsListAndLastResults(res, store));
}

export function getNextEventsTime(store) {
    fetchNextEventsTime()
        .then((res) => handleFetchNextEventsTime(res, store));
}


/*
  Another chapter on IE11 features that make our life so exciting...

  IE11 brutally caches all GET calls to rest endpoints for no apparent reason leaving us with problems
  on fetching next events time after the first GET call.

  This usually is worked around by adding headers to the GET request but, since IE11 does not support fetch API
  we had to pollyfil it and, the current one we are using, does not support cache no-store headers.

  We had to trick IE into stop returning cached GET responses adding a non repeating parameter
  to the url which will lead IE to believe that every request is done to a new endpoint.

  i.e. http://plugnplay-l1.inseincvirtuals.com/bms-logic/nextEvents/2?cacheBuster=5455646546456456

  This (stupid exception for IE11 once again) is not pretty but it is functional and has low impact on
  other browsers since chrome and firefox actively fetch GET requests to the server every time ignoring previously
  cached requests out of the box.
*/

function fetchNextEventsTime() {
    return new Promise((resolve, reject) => {
        let nextEventTimeURL = BMS_LOGIC + '/nextEvents/5';
        fetch(nextEventTimeURL).then(checkFetchResponseStatus).then(parseFetchResponseJSON).then((res) => resolve(res)).catch(err => {
            reject(err);
            throw err;
        });
    });
}

function fetchNextEventsListAndLastResults(gameChannel, gameType) {
    return new Promise((resolve, reject) => {
        // Added NEXT_EVENT_DISPLAY_MODE for sisal integration
        let numberOfEvents = NEXT_EVENT_DISPLAY_MODE === CURRENT_NEXT ? 
                gameType === MATCHDAY_MODULE_TYPE ? 24 : 3 
                    : gameType === MATCHDAY_MODULE_TYPE ? isTextBasedGame(gameChannel) ? 48 : 32
                        : 9
        let nextEventTimeURL = `${BMS_LOGIC}/channel/${gameChannel}/nextEvents/${numberOfEvents}`;
        fetch(nextEventTimeURL).then(checkFetchResponseStatus).then(parseFetchResponseJSON).then((res) => resolve(res)).catch(err => {
            reject(err);
            throw err;
        });
    });
}


// WEBPACK FOOTER //
// ./src/communications/platformMessageRequests.js